import { Col, FormikSelect, Modal, Panel, Row } from '@elotech/components';
import { InlineButton } from 'common/components';
import { ReportDTO } from 'common/type';
import { Form, Formik } from 'formik';
import { FormGroup } from 'react-bootstrap';

type Props = {
  setShowModal: (value: boolean) => void;
  relatorios: ReportDTO[];
  onEmitirRelatorio: (id: string, params?: never) => void;
  open?: boolean;
  loading?: boolean;
};

export const RelatoriosDinamicosModal = ({
  setShowModal,
  relatorios,
  onEmitirRelatorio,
  open = true,
  loading
}: Props) => {
  if (!open) return null;

  return (
    <Modal onClose={() => setShowModal(false)} maxWidth="25%">
      <Panel title="Emitir Relatório" isForm>
        <Formik<{
          relatorioId?: string;
        }>
          enableReinitialize
          onSubmit={values =>
            values.relatorioId && onEmitirRelatorio(values.relatorioId)
          }
          initialValues={{
            relatorioId: undefined
          }}
        >
          {formProps => {
            return (
              <Form>
                <FormikSelect<ReportDTO>
                  name="relatorioId"
                  label="Relatório"
                  getOptionLabel={value => value.name}
                  getOptionValue={value => value.id}
                  options={relatorios}
                  size={12}
                />
                <Row>
                  <Col md={12} sm={12} className="mt-xs right">
                    <FormGroup>
                      <InlineButton
                        label="Emitir"
                        onClick={formProps.submitForm}
                        disabled={!formProps.values.relatorioId || loading}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </Panel>
    </Modal>
  );
};
